import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { animeList, categories } from '@/mocks/anime';
import CategoryHero from './components/CategoryHero';
import AnimeList from './components/AnimeList';
import EditorPick from './components/EditorPick';

export default function Category() {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();

  const currentSlug = slug || 'action';
  const category = categories.find((c) => c.slug === currentSlug);
  const categoryName = category?.name || '动漫分类';

  const filteredAnime = animeList.filter((a) => a.categorySlug === currentSlug);

  useEffect(() => {
    document.title = `${categoryName}动漫-免费在线观看-樱花动漫网`;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [categoryName]);

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `樱花动漫-${categoryName}分类`,
          description: `樱花动漫网${categoryName}动漫分类，免费在线观看${categoryName}类动漫，手机随时随地畅快追番`,
          url: `http://kktyvqy.cn/category/${currentSlug}`,
          isPartOf: {
            '@type': 'WebSite',
            name: '樱花动漫网',
            url: 'http://kktyvqy.cn/',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: t('首页'), item: 'http://kktyvqy.cn/' },
            { '@type': 'ListItem', position: 2, name: categoryName, item: `http://kktyvqy.cn/category/${currentSlug}` },
          ],
        }}
      />

      <Navbar />

      <main>
        <CategoryHero categoryName={categoryName} />

        <div className="bg-background-50 border-b border-background-200/70">
          <div className="px-4 md:px-6">
            <div className="flex items-center gap-1 overflow-x-auto py-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    currentSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <Breadcrumb items={[{ label: t('分类'), to: '/category/action' }, { label: categoryName }]} />

        <AnimeList animeList={filteredAnime} categoryName={categoryName} />
        <EditorPick />
      </main>

      <Footer />
    </>
  );
}